import React, { useRef } from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
const artworks = [{
  id: 1,
  title: 'The Bath',
  src: 'https://i.imgur.com/EddDQH9.png'
}, {
  id: 2,
  title: 'Holy Penthouse Batman',
  src: 'https://i.imgur.com/YZu0ISL.jpeg'
}, {
  id: 3,
  title: 'Digital Lens',
  src: 'https://i.imgur.com/mxEvpSR.jpeg'
}, {
  id: 4,
  title: 'Three Gorges Cultural Center',
  src: 'https://i.imgur.com/PcGOR9d.jpeg'
}, {
  id: 5,
  title: 'Cube Prism',
  src: 'https://i.imgur.com/9fttiNG.jpeg'
}];
export function ArtGallery() {
  const {
    ref,
    isVisible
  } = useScrollReveal(0.1);
  const scrollRef = useRef<HTMLDivElement>(null);
  return <section className="py-32 relative overflow-hidden" data-id="element-27">
      <div className="max-w-7xl mx-auto px-6 mb-16" data-id="element-28">
        <h2 ref={ref} className={`text-4xl md:text-6xl font-light uppercase tracking-[0.3em] text-white mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-29">
          Visual Explorations
        </h2>
      </div>

      <div ref={scrollRef} className="flex overflow-x-auto gap-8 px-6 pb-12 snap-x snap-mandatory scrollbar-hide" style={{
      scrollBehavior: 'smooth',
      WebkitOverflowScrolling: 'touch'
    }} data-id="element-30">
        {artworks.map((art, i) => <div key={art.id} className="flex-none w-[85vw] md:w-[600px] snap-center group relative rounded-2xl overflow-hidden aspect-[4/3]" data-id="element-31">
            <img src={art.src} alt={art.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-32" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-33">
              <div className="absolute bottom-0 left-0 p-8" data-id="element-34">
                <span className="text-white/60 text-sm uppercase tracking-wider mb-2 block" data-id="element-35">
                  0{i + 1}
                </span>
                <h3 className="text-2xl font-bold text-white" data-id="element-36">{art.title}</h3>
              </div>
            </div>
          </div>)}
        {/* Spacer for end of list */}
        <div className="w-6 flex-none" data-id="element-37" />
      </div>
    </section>;
}